<ae-view-mailing-list
  (closeDialog)="close()"
  [isDialog]="true"
  [mailingListId]="mailingListId"
>
</ae-view-mailing-list>
